class ScrollImageSequence {
  constructor(wrapperElement) {
    this.wrapper = wrapperElement;
    this.imageContainer = wrapperElement.querySelector('[data-image-container]');
    this.images = Array.from(wrapperElement.querySelectorAll('.scroll-sequence-image'));

    // Marquee elements and positions
    this.marqueeContainer = wrapperElement.querySelector('[data-marquee-container]');
    this.marqueeContent = this.marqueeContainer ? this.marqueeContainer.querySelector('.scroll-marquee__content') : null;

    // State
    this.currentImageIndex = 0;

    // Check if animation should be disabled
    if (this.shouldDisableAnimation()) {
      this.init();
      this.wrapper.click();
      return;
    }

    this.init();
  }



  /**
   * Check if animation should be disabled
   */
  shouldDisableAnimation() {
    // Respect user's motion preferences
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return true;
    }

    // Disable if not enough images
    if (this.images.length < 2) {
      return true;
    }

    return false;
  }


  /**
   * Initialize the scroll animation
   */
  init() {
    this.wrapper.addEventListener('click', this.toggleMarqueeAnimation);
    this.preloadImages();
    this.startImageAutoAnimation();
    this.startMarqueeAutoAnimation();
  }

  startImageAutoAnimation() {
    const switchInterval = 2000; // 2 seconds
    const totalDuration = 30000; // 30 seconds
    let elapsed = 0;
    let intervalId = null;
    let startTime = null;
    let pausedTime = 0;
    let isPaused = false;

    const startAnimation = () => {
      if (intervalId) return; // avoid duplicates
      startTime = Date.now() - pausedTime;

      intervalId = setInterval(() => {
        if (isPaused) return;

        this.currentImageIndex++;
        if (this.currentImageIndex >= this.images.length) {
          this.currentImageIndex = 0;
        }
        this.switchToImage(this.currentImageIndex);

        elapsed = Date.now() - startTime;
        if (elapsed >= totalDuration) {
          clearInterval(intervalId);
          intervalId = null;
        }
      }, switchInterval);
    };

    const pauseAnimation = () => {
      if (!intervalId) return;
      isPaused = true;
      pausedTime = Date.now() - startTime;
    };

    const resumeAnimation = () => {
      if (!isPaused) return;
      isPaused = false;
    };

    // Optional: toggle pause/resume on click
    this.wrapper.addEventListener("click", () => {
      if (isPaused) {
        resumeAnimation();
      } else {
        pauseAnimation();
      }
    });

    // Initialize
    this.currentImageIndex = 0;
    this.switchToImage(this.currentImageIndex);
    startAnimation();
  }



  /**
   * Preload all images for smooth transitions
   */
  preloadImages() {
    this.images.forEach(img => {
      if (!img.complete) {
        const tempImg = new Image();
        tempImg.src = img.src;
      }
    });
  }


  /**
   * Switch to a specific image with smooth transition
   */
  switchToImage(index) {
    // Remove active class from all images
    this.images.forEach((img, i) => {
      if (i === index) {
        img.classList.add('active');
      } else {
        img.classList.remove('active');
      }
    });

    this.currentImageIndex = index;

    // Dispatch custom event for potential external listeners
    this.wrapper.dispatchEvent(new CustomEvent('imagechange', {
      detail: { index, totalImages: this.images.length }
    }));
  }

  /**
   * Add repeated elements to marquee and start marquee auto animation
   */
  startMarqueeAutoAnimation() {
    const calculateNumberOfCopies = () => {
      const content = this.marqueeContent;
      const marqueeWidth = this.marqueeContainer.offsetWidth;
      const marqueeRepeatedItemWidth =
        content.firstElementChild instanceof HTMLElement ? content.firstElementChild.offsetWidth : 1;
      return marqueeRepeatedItemWidth === 0 ? 1 : Math.ceil(marqueeWidth / marqueeRepeatedItemWidth);
    }
    // console.log(calculateNumberOfCopies());

    const addRepeatedItems = (numberOfCopies = calculateNumberOfCopies()) => {
      const content = this.marqueeContent;
      const wrapper = this.marqueeContainer;

      if (!content) return;

      for (let i = 0; i < numberOfCopies - 1; i++) {
        const clone = content.cloneNode(true);
        wrapper.appendChild(clone);
      }
    }

    addRepeatedItems();
  }

  /**
   * Toggle marquee animation
   */
  toggleMarqueeAnimation() {
    const marquee = this.querySelector('[data-marquee-container]');
    // const animation = marquee.getAnimations()[0];
    // console.log(animation);
    marquee?.classList.toggle('auto-animate');
    this.querySelector('.play')?.classList.toggle('hidden');
    this.querySelector('.stop')?.classList.toggle('hidden');
  }

}

/**
 * Initialize all scroll image sequence sections on the page
 */
function initScrollImageSequences() {
  const sections = document.querySelectorAll('[data-scroll-sequence]');

  sections.forEach(section => {
    // Store instance on element for potential future access
    section.scrollImageSequence = new ScrollImageSequence(section);
  });
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initScrollImageSequences);
} else {
  initScrollImageSequences();
}

// Re-initialize on Shopify theme editor section load
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-scroll-sequence]');
    if (section && !section.scrollImageSequence) {
      section.scrollImageSequence = new ScrollImageSequence(section);
    }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.querySelector('[data-scroll-sequence]');
    if (section && section.scrollImageSequence) {
      section.scrollImageSequence.destroy();
      section.scrollImageSequence = null;
    }
  });
}
